module.exports = __webpack_public_path__ + "static/0chain-healthcare-6b45a46c6faaa230b19e3470ea9b70a4.png";